import { TYPES, INPUTS, FIELD_INPUTS } from '@/entities/fields'

export const VALIDATORS = {
    required: {
        key: 'required',
        type: FIELD_INPUTS[TYPES.BOOL],
        defaultValue: false,
    },
    unique: {
        key: 'unique',
        type: FIELD_INPUTS[TYPES.BOOL],
        defaultValue: false,
    },
    minValue: {
        key: 'minValue',
        type: FIELD_INPUTS[TYPES.INT],
        defaultValue: '',
    },
    maxValue: {
        key: 'maxValue',
        type: FIELD_INPUTS[TYPES.INT],
        defaultValue: '',
    },
    minDate: {
        key: 'minDate',
        type: FIELD_INPUTS[TYPES.DATE],
        defaultValue: '',
    },
    maxDate: {
        key: 'maxDate',
        type: FIELD_INPUTS[TYPES.DATE],
        defaultValue: '',
    },
}

const VALIDATORS_COMMON = [VALIDATORS.required, VALIDATORS.unique]

export const FIELD_VALIDATORS_TYPES = {
    [INPUTS.TEXT]: VALIDATORS_COMMON,
    [INPUTS.NUMBER]: [...VALIDATORS_COMMON, VALIDATORS.minValue, VALIDATORS.maxValue],
    [INPUTS.DATE]: [...VALIDATORS_COMMON, VALIDATORS.minDate, VALIDATORS.maxDate],
    [INPUTS.SELECT]: [VALIDATORS.required],
}

export default {
    VALIDATORS,
    FIELD_VALIDATORS_TYPES,
}
